import { render, staticRenderFns } from "./portal_Product-info-desciptionAndAttrs.vue?vue&type=template&id=c1f2d928&scoped=true&"
import script from "./portal_Product-info-desciptionAndAttrs.vue?vue&type=script&lang=js&"
export * from "./portal_Product-info-desciptionAndAttrs.vue?vue&type=script&lang=js&"
import style0 from "./portal_Product-info-desciptionAndAttrs.vue?vue&type=style&index=0&id=c1f2d928&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f2d928",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
